import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeService {

  apiUrl: string = environment.apiUrlV2;
  constructor(private http: HttpClient) { }

  unsubscribe(patientId: number, token: string): Observable<any> {
    const params = new HttpParams()
      .set('patient_id', patientId.toString())
      .set('unsubscribeToken', token);

    return this.http.get(`${this.apiUrl}/unsubscribe`, { params });
  }
}

